import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@utils';

interface TokenResponse {
  valid: boolean;
  message?: string;
}

export const useCheckResetPasswordToken = (token: string) =>
  useQuery({
    queryKey: ['reset-token', token],
    queryFn: async (): Promise<TokenResponse> => {
      if (!token) return { valid: false, message: 'No token provided' };
      const result = await apiClient.user.checkResetPassword.mutation({ body: { resetToken: token } });
      if (result.status === 200) return result.body as TokenResponse;
      return { valid: false, message: (result.body as any).message };
    },
    enabled: !!token,
  });
